'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('~~', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/locate/delete.js
// module id = 478
// module chunks = 35783957827783